import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["display_name", "Nom"],
  ["device_type", "Type d'appareil"],
  ["site", "Site"],
  ["department", "Département"],
];

export const EditMachineDialog = ({ machine, groups, open, onOpenChange, onSaved }) => {
  const [form, setForm] = useState({});
  useEffect(() => {
    if (machine) setForm({ display_name: machine.display_name || machine.hostname, device_type: machine.device_type || "", site: machine.site || "", department: machine.department || "", group_id: machine.group_id || "none" });
  }, [machine?.machine_id, open]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!machine) return null;

  const save = async () => {
    try {
      await api.patch(`/machines/${machine.machine_id}`, form);
      toast.success("Machine modifiée");
      onOpenChange(false);
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="edit-machine-dialog">
        <DialogHeader><DialogTitle>Modifier {machine.hostname}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {FIELDS.map(([k, label]) => (
            <label key={k} className="block text-sm">
              <span className="text-slate-600">{label}</span>
              <Input data-testid={`edit-${k}-input`} className="mt-1" value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
            </label>
          ))}
          <label className="block text-sm">
            <span className="text-slate-600">Entreprise</span>
            <Select value={form.group_id} onValueChange={(v) => setForm({ ...form, group_id: v })}>
              <SelectTrigger className="mt-1" data-testid="edit-group-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Non classé</SelectItem>
                {groups.map((g) => <SelectItem key={g.group_id} value={g.group_id}>{g.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </label>
        </div>
        <DialogFooter><Button onClick={save} data-testid="edit-machine-save-btn">Enregistrer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
